module.exports = __webpack_public_path__ + "a9aac1261e5751ff9ae598abd3414cdf.svg";